<template>
  <label @click="click" :for="name" :class="{ active, disabled, error }">
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: "InputLabel",
  props: {
    name: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    error: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    click() {
      this.$emit("clicked");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
label {
  position: absolute;
  top: 0;
  left: $padding-input-left;
  transform: translateY($font-size-md);

  font-size: $font-size-md;
  color: $label-gray;
  font-weight: 400;
  transition: $transition-simple-fast;
  z-index: 2;
  cursor: pointer;

  &.active {
    color: $blue-navy;
    font-size: $font-size-xxs;
    transform: translateY(8px);
  }

  &.error {
    color: $red-active;
  }

  &.disabled {
    color: $label-gray;
    cursor: default;
  }
}
</style>
